import { render, staticRenderFns } from "./IconClouduploadAlt.vue?vue&type=template&id=471c122c&scoped=true&"
import script from "./IconClouduploadAlt.vue?vue&type=script&lang=js&"
export * from "./IconClouduploadAlt.vue?vue&type=script&lang=js&"
import style0 from "./IconClouduploadAlt.vue?vue&type=style&index=0&id=471c122c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c122c",
  null
  
)

export default component.exports